import { FunctionComponent, useState } from "react";
import POSUM from "../../assets/pictures/NFZ/POSUM.jpg";
import Location from "../../assets/pictures/Icons/location";
import Phone from "../../assets/pictures/Icons/phone";
import Email from "../../assets/pictures/Icons/email";
import { Alert, Flex, Modal } from "antd";
import Important from "../../assets/pictures/Icons/warning";
import Prescription from "../../assets/pictures/Icons/prescription";
import X from "../../assets/pictures/Icons/X";
import Kid from "../../assets/pictures/Icons/kid";
import Info from "../../assets/pictures/Icons/info";
import RegisterIcon from "../../assets/pictures/Icons/register";
import Clinic from "../../assets/pictures/NFZ/gabinet.jpg";
import {
  FaBus,
  FaParking,
  FaXRay,
  FaFlask,
  FaPills,
  FaCrutch,
  FaUserMd,
  FaMoon,
  FaChild,
  FaWheelchair,
} from "react-icons/fa";
import CalendarIcon from "../../assets/pictures/Icons/calendar";
import { FiAlertCircle } from "react-icons/fi";

interface NFZProps {}

const NFZ: FunctionComponent<NFZProps> = () => {
  const [openRegister, setOpenRegister] = useState(false);

  const openLocation = () => {
    window.open(
      "https://www.google.pl/maps/place/Pozna%C5%84ski+O%C5%9Brodek+Specjalistycznych+Us%C5%82ug+Medycznych/@52.4334424,16.9317481,17z/data=!4m13!1m7!3m6!1s0x47045ca96fc01b8b:0x9b95bdeba8ad3e2e!2sAleje+Solidarno%C5%9Bci+36,+61-696+Pozna%C5%84!3b1!8m2!3d52.4334391!4d16.9339368!3m4!1s0x47045ca97ca540c9:0x799eb0e132b55933!8m2!3d52.4332739!4d16.9340555?shorturl=1",
      "_blank"
    );
  };

  const handleOpenCloseRegister = () => {
    setOpenRegister(!openRegister);
  };

  const handleOpenRegisterWebsite = () => {
    window.open(
      "https://lekarzebezkolejki.pl/placowka/mariusz-sroczynski/chirurg-dzieciecy/poznan",
      "_blank"
    );
    handleOpenCloseRegister();
  };

  return (
    <div className="nfz-section" id="nfz">
      <div className="title">
        <h2>Poradnia Chirurgii Dziecięcej - NFZ</h2>
      </div>
      <div className="intro">
        <div className="image">
          <img src={POSUM} alt="POSUM" onClick={openLocation} />
        </div>

        <div className="intro-text">
          <h3>Poznański Ośrodek Specjalistycznych Usług Medycznych</h3>
          <div className="info">
            <div className="icon-text">
              <Location />
              <p>Al. Solidarności 36, Poznań - W godz. 7.30 - 19.00</p>
            </div>
            <div className="icon-text">
              <Phone />
              <p>61 647 77 80 - W godz. 8.30 - 16.00</p>
            </div>
            <div className="icon-text">
              <Email />
              <p>rejestracja@posum.pl</p>
            </div>
            <h4>Harmonogram moich przyjęć</h4>
            <div className="icon-text">
              <CalendarIcon className="stroke" />
              <p>Czwartki 08.30-14.30</p>
            </div>
            <div className="icon-text">
              <CalendarIcon className="stroke" />
              <p>Piątki 08.30-13.30</p>
            </div>
          </div>
          <div className="button-wrapper">
            <button className="button-secondary" onClick={openLocation}>
              Lokalizacja
            </button>
            <button
              className="button-primary"
              onClick={handleOpenCloseRegister}
            >
              Umów wizytę
            </button>
          </div>
        </div>
      </div>
      <div className="subsection">
        <div className="title">
          <h3>Najczęściej leczone schorzenia</h3>
        </div>
        <CommonConditions />
      </div>
      <div className="subsection">
        <div className="title">
          <h3>Dlaczego warto wybrać naszą poradnię?</h3>
        </div>
        <ClinicFeatures />
      </div>

      <Modal
        centered
        open={openRegister}
        onCancel={handleOpenCloseRegister}
        title="Umów wizytę"
        footer={null}
        width="100%"
        style={{
          maxWidth: "1000px",
        }}
      >
        <Flex
          vertical
          style={{
            padding: "1rem 0",
          }}
          gap="middle"
        >
          <div className="alert">
            <FiAlertCircle className="alert-icon" />
            <p>Kilka ważnych informacji przed umówieniem wizyty</p>
          </div>
          <Flex className="points-wrapper" vertical gap="0.5rem">
            <div className="point">
              <Prescription className="stroke" />
              <p>
                Pacjent musi posiadać skierowanie od lekarza rodzinnego lub
                innego lekarza mającego umowę z NFZ.
              </p>
            </div>
            <div className="point">
              <Important className="important" />
              <p className="important">
                Pacjent będzie przyjęty bez skierowania w nagłych przypadkach
                takich jak: rana, oparzenie, podejrzenie złamania, skręcenia
                stawów, uraz głowy, nagły silny ból brzucha czy jąder.
              </p>
            </div>
            <div className="point">
              <X className="fill" />
              <p>
                Skierowania z gabinetów prywatnych, działających poza NFZ nie są
                honorowane.
              </p>
            </div>
            <div className="point">
              <X className="fill" />
              <p>
                Karta informacyjna ze szpitala, pogotowia nie jest skierowaniem.
              </p>
            </div>
            <div className="point">
              <RegisterIcon className="fill" />
              <p>Celem prawidłowego rejestrowania potrzebne będą:</p>
            </div>
            <Flex vertical gap="0.25rem">
              <div className="sub-point">
                <Info className="fill" />
                <p>Imię i nazwisko dziecka.</p>
              </div>
              <div className="sub-point">
                <Kid className="fill" />
                <p>
                  PESEL dziecka, w przypadku noworodków - PESEL jednego z
                  rodziców.
                </p>
              </div>
              <div className="sub-point">
                <Location className="stroke" />
                <p>Adres faktycznego zamieszkania z kodem pocztowym.</p>
              </div>
              <div className="sub-point">
                <Phone className="fill" />
                <p>Telefon kontaktowy do rodzica lub prawnego opiekuna.</p>
              </div>
            </Flex>
          </Flex>
        </Flex>
        <Flex justify="flex-end" gap="middle">
          <button
            className="button-secondary"
            onClick={handleOpenCloseRegister}
          >
            Zamknij
          </button>
          <button
            className="button-primary"
            onClick={handleOpenRegisterWebsite}
          >
            Umów wizytę samodzielnie
          </button>
        </Flex>
      </Modal>
    </div>
  );
};

export default NFZ;

const CommonConditions = () => {
  const conditions = [
    {
      icon: "🩺",
      title: "Kontrole dzieci leczonych",
      description: "Oddziały chirurgii dziecięcej w Polsce i poza granicami.",
    },
    {
      icon: "🚑",
      title: "Nagłe urazy",
      description:
        "Szycie ran, nastawianie zwichnięć stawów, pomoc w skręceniu stawu skokowego, urazach palców.",
    },
    {
      icon: "💢",
      title: "Przepuklina pachwinowa",
      description: "Diagnostyka i leczenie przepukliny pachwinowej.",
    },
    {
      icon: "🔵",
      title: "Przepuklina pępkowa",
      description: "Leczenie przepukliny pępkowej u dzieci.",
    },
    {
      icon: "🧵",
      title: "Nieodpadnięty kikut pępowinowy",
      description: "Specjalistyczna pomoc w takich przypadkach.",
    },
    {
      icon: "⚽",
      title: "Wnętrostwo",
      description: "Leczenie niezstąpionego jądra, jądra wędrującego.",
    },
    {
      icon: "🛠️",
      title: "Stulejka, sklejenie napletka",
      description: "Diagnoza i leczenie stulejki oraz sklejenia napletka.",
    },
    {
      icon: "🔥",
      title: "Oparzenia",
      description: "Leczenie oparzeń różnego stopnia.",
    },
    {
      icon: "💉",
      title: "Zmiany skórne",
      description: "Leczenie znamion barwnikowych, kaszaków, brodawek.",
    },
    {
      icon: "📉",
      title: "Zaparcja i krwawienia z odbytu",
      description:
        "Pomoc w zaparciach, szczelinach odbytu, zmianach okolicy odbytu.",
    },
    {
      icon: "🧬",
      title: "Wrodzone wady rozwojowe",
      description: "Diagnostyka i leczenie wad wrodzonych u dzieci.",
    },
    {
      icon: "👅",
      title: "Krótkie wędzidełko języka",
      description: "Podcięcie krótkiego wędzidełka języka.",
    },
  ];

  return (
    <div className="card-grid">
      {conditions.map((condition, index) => (
        <div className="card" key={index}>
          <div className="icon">{condition.icon}</div>
          <h2 className="card-title">{condition.title}</h2>
          <p className="card-description">{condition.description}</p>
        </div>
      ))}
    </div>
  );
};

const ClinicFeatures = () => {
  const features = [
    {
      icon: <FaBus />,
      description: "Dogodny dojazd komunikacją miejską - autobusy i tramwaje.",
    },
    {
      icon: <FaParking />,
      description: "Płatny, strzeżony parking przed budynkiem.",
    },
    {
      icon: <FaXRay />,
      description: "RTG na miejscu czynne w godzinach 8:00 - 18:00.",
    },
    {
      icon: <FaFlask />,
      description: 'Laboratorium "Diagnostyka Sp. z o.o." dostępne na miejscu.',
    },
    { icon: <FaPills />, description: "Apteka 24h - otwarta przez całą dobę." },
    {
      icon: <FaCrutch />,
      description: "Sklep z zaopatrzeniem ortopedycznym czynny 10:00 - 17:00.",
    },
    {
      icon: <FaUserMd />,
      description: "Kilkudziesięciu lekarzy specjalistów oraz lekarz rodzinny.",
    },
    {
      icon: <FaMoon />,
      description: 'Nocna i świąteczna pomoc doraźna - tzw. "wieczorynka".',
    },
    { icon: <FaChild />, description: "Kącik zabaw dla dzieci w poczekalni." },
    {
      icon: <FaWheelchair />,
      description: "Wszelkie udogodnienia dla osób niepełnosprawnych.",
    },
  ];

  return (
    <section className="clinic-features">
      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-item" key={index}>
            <div className="icon">{feature.icon}</div>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
